import { Box, Typography, useTheme } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { tokens } from '../../../theme';
import { formatCompact, formatPercent } from '../../utils/dashboardUtils';

const DashboardKpiCard = ({
  label, value, prevLabel, prevValue, pct, increased, isPercent = false, format = 'compact',
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const display = format === 'percent' || isPercent
    ? formatPercent(value)
    : format === 'number' ? String(value) : formatCompact(value);
  const prevDisplay = format === 'percent' || isPercent
    ? formatPercent(prevValue)
    : format === 'number' ? String(prevValue) : formatCompact(prevValue);

  return (
    <Box bgcolor={colors.primary[400]} p={1.5} height="100%" display="flex" flexDirection="column" justifyContent="space-between">
      <Typography variant="caption" color={colors.grey[300]} fontWeight={500}>{label}</Typography>
      <Typography variant="h4" fontWeight={700} color={colors.grey[100]}>{display}</Typography>
      {prevLabel && (
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={0.5}>
          <Typography variant="caption" color={colors.grey[400]}>{prevDisplay} {prevLabel}</Typography>
          <Box display="flex" alignItems="center" gap={0.25}>
            {increased
              ? <ArrowUpward sx={{ fontSize: 14, color: colors.greenAccent[400] }} />
              : <ArrowDownward sx={{ fontSize: 14, color: '#e2726e' }} />}
            <Typography variant="caption" color={increased ? colors.greenAccent[400] : '#e2726e'} fontWeight={600}>
              {Math.abs(pct)}%
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DashboardKpiCard;
